import { render } from "./VersionCard.vue?vue&type=template&id=1e7a37dd&ts=true"
import script from "./VersionCard.vue?vue&type=script&lang=ts"
export * from "./VersionCard.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/hubevt/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__